import { NgModule } from "@angular/core";
import { CommonModule } from "@angular/common";
import { SegmentComponent } from "./segment.component";
import { DatePipeModule } from "../date/date.module";
import { LuggageModule } from "../luggage/luggage.module";
import { CarbonFootprintModule } from "../component/carbon-footprint/carbon-footprint.module";
import { StopsModule } from "../component/stops/stops.module";
import { AirLogoPipe } from "libraries/segment/air-logo.pipe";
import { LanguageService } from "libraries/service/language/language.service";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { FareFamilyModule } from "../component/fare-family/fare-family.module";
import { UrlWithDomainModule } from "libraries/pipes/url-with-domain/url-with-domain.module";
import { PermissionModule } from "libraries/permission/permission.module";
import {OverlayModule} from "@angular/cdk/overlay";

@NgModule({
    imports: [
        CarbonFootprintModule,
        CommonModule,
        DatePipeModule,
        FareFamilyModule,
        FontAwesomeModule,
        LuggageModule,
        PermissionModule,
        StopsModule,
        UrlWithDomainModule,
        OverlayModule,
    ],
    declarations: [
        SegmentComponent,
        AirLogoPipe,
    ],
    exports: [
        SegmentComponent,
    ],
    providers: [
        LanguageService,
    ]
})
export class SegmentModule {
}
